'use es6';

import Immutable from 'immutable';
import VersionInfo from './VersionInfo';
import { cleanObject } from '../utils/formatters';
const EMPTY_LIST = Immutable.List();
const defaults = {
  versionHistory: EMPTY_LIST,
  total: 0
};

class VersionHistoryResponse extends Immutable.Record(defaults) {
  constructor(json = {}) {
    const jsonCopy = Object.assign({}, json);

    if (json.versionHistory) {
      jsonCopy.versionHistory = Immutable.List(json.versionHistory.map(value => new VersionInfo(value)));
    }

    super(cleanObject(jsonCopy));
  }

}

export default VersionHistoryResponse;